import { default as aboutGJBVrK2XklMeta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsaiRXultNStMeta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93jzDQgElYzeMeta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleybCYxppoIEMeta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsCIDJDZBgm2Meta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93hzLFKfDHvuMeta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as view3JcdOsCj1gMeta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexz6wtaRZ6jkMeta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93ow2teSlbLTMeta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexvApLArBcMqMeta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93uRr6tKM6WCMeta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexmxIyuyL5AcMeta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsY1xU2K4ihoMeta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsCixi4aOj0eMeta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsiMKMrCMSvPMeta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93BySCZWGw0mMeta } from "/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexlwem1qFIN7Meta } from "/tmp/build_dab1367c/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmLzwCAOlgM3Meta } from "/tmp/build_dab1367c/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmqrfRMP1HEdMeta } from "/tmp/build_dab1367c/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendarrNRegQNR8cMeta } from "/tmp/build_dab1367c/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatIRvQOexAWjMeta } from "/tmp/build_dab1367c/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutYp507B95RGMeta } from "/tmp/build_dab1367c/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedrPVz3zroV1Meta } from "/tmp/build_dab1367c/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersO0TEUKboGkMeta } from "/tmp/build_dab1367c/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93ZoQWXxwFB3Meta } from "/tmp/build_dab1367c/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editT111zk0tOqMeta } from "/tmp/build_dab1367c/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93QKNk9BMWa8Meta } from "/tmp/build_dab1367c/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityfC40m4lq8EMeta } from "/tmp/build_dab1367c/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93l866JU0t7IMeta } from "/tmp/build_dab1367c/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93oJGmmYZ8PFMeta } from "/tmp/build_dab1367c/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardPrV3Wtl38AMeta } from "/tmp/build_dab1367c/pages/[studio_url]/dashboard.vue?macro=true";
import { default as index8UXKEQZfqPMeta } from "/tmp/build_dab1367c/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutoF8P7vcY2kMeta } from "/tmp/build_dab1367c/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45producthfbN0RR1A5Meta } from "/tmp/build_dab1367c/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsS3Aj56D0IpMeta } from "/tmp/build_dab1367c/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93jFdyS7VgPSMeta } from "/tmp/build_dab1367c/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexhHawesFwW5Meta } from "/tmp/build_dab1367c/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93qvDh7XxmO2Meta } from "/tmp/build_dab1367c/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93mhV0xyf4BwMeta } from "/tmp/build_dab1367c/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexkbQrUzdVF5Meta } from "/tmp/build_dab1367c/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93XG3kOnt5PtMeta } from "/tmp/build_dab1367c/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as join5gQM8bYl5tMeta } from "/tmp/build_dab1367c/pages/[studio_url]/join.vue?macro=true";
import { default as loginqDm0AI38OvMeta } from "/tmp/build_dab1367c/pages/[studio_url]/login.vue?macro=true";
import { default as logoutuSpskN8JKAMeta } from "/tmp/build_dab1367c/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93iCzgYgO4b0Meta } from "/tmp/build_dab1367c/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93mQc9Ysox6gMeta } from "/tmp/build_dab1367c/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93QnmUZRPM6yMeta } from "/tmp/build_dab1367c/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritesdQu5vRRAjaMeta } from "/tmp/build_dab1367c/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studios5kFZKHyEsGMeta } from "/tmp/build_dab1367c/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinkl9nLeym6BMeta } from "/tmp/build_dab1367c/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93LhMhpW7DyQMeta } from "/tmp/build_dab1367c/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as index4ijeRyOO23Meta } from "/tmp/build_dab1367c/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as indexOpo5SI00N8Meta } from "/tmp/build_dab1367c/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as abouteMpAICp2a6Meta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentZpLP0nxDlOMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventsrJG3FeGTSBMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93rElh8p6KEkMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplelIyAZwMOlGMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45products8jcVU0XEbJMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_934Dzgs6aLpxMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewB6HCLqYP6HMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexXqgQjsAB4WMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_934nFxAfhxatMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexIwUYvnamPJMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93tLkijbg5oKMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexuixxtkeLM9Meta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsRuhCfs8giPMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsYvDKhGAN1EMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsRwP6b233BWMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93JwpfIqydBGMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexYgQNfQIjxJMeta } from "/tmp/build_dab1367c/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexS9uRpWNldrMeta } from "/tmp/build_dab1367c/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasessqgMJn5MXCMeta } from "/tmp/build_dab1367c/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsvSZsTpeFCDMeta } from "/tmp/build_dab1367c/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93frtiazd1lUMeta } from "/tmp/build_dab1367c/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93htDjb7xl7FMeta } from "/tmp/build_dab1367c/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as reset079y3IPYJoMeta } from "/tmp/build_dab1367c/pages/[studio_url]/reset.vue?macro=true";
import { default as shopXl5b4CIyHmMeta } from "/tmp/build_dab1367c/pages/[studio_url]/shop.vue?macro=true";
import { default as signup06fyJR2taPMeta } from "/tmp/build_dab1367c/pages/[studio_url]/signup.vue?macro=true";
import { default as liveK1oSrpgVlLMeta } from "/tmp/build_dab1367c/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsjlGxeXN7ZfMeta } from "/tmp/build_dab1367c/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93dnnDL20LjsMeta } from "/tmp/build_dab1367c/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactijbODdiXhzMeta } from "/tmp/build_dab1367c/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fullGswt0OjUkRMeta } from "/tmp/build_dab1367c/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93BySCZWGw0mMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93BySCZWGw0mMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93BySCZWGw0mMeta || {},
    alias: _91product_id_93BySCZWGw0mMeta?.alias || [],
    redirect: _91product_id_93BySCZWGw0mMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutGJBVrK2XklMeta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutGJBVrK2XklMeta?.path ?? "about",
    meta: aboutGJBVrK2XklMeta || {},
    alias: aboutGJBVrK2XklMeta?.alias || [],
    redirect: aboutGJBVrK2XklMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsaiRXultNStMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsaiRXultNStMeta?.path ?? "events",
    meta: eventsaiRXultNStMeta || {},
    alias: eventsaiRXultNStMeta?.alias || [],
    redirect: eventsaiRXultNStMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93jzDQgElYzeMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93jzDQgElYzeMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93jzDQgElYzeMeta || {},
    alias: _91media_id_93jzDQgElYzeMeta?.alias || [],
    redirect: _91media_id_93jzDQgElYzeMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleybCYxppoIEMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sampleybCYxppoIEMeta?.path ?? "free-sample",
    meta: free_45sampleybCYxppoIEMeta || {},
    alias: free_45sampleybCYxppoIEMeta?.alias || [],
    redirect: free_45sampleybCYxppoIEMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsCIDJDZBgm2Meta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsCIDJDZBgm2Meta?.path ?? "included-products",
    meta: included_45productsCIDJDZBgm2Meta || {},
    alias: included_45productsCIDJDZBgm2Meta?.alias || [],
    redirect: included_45productsCIDJDZBgm2Meta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93hzLFKfDHvuMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93hzLFKfDHvuMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93hzLFKfDHvuMeta || {},
    alias: _91media_id_93hzLFKfDHvuMeta?.alias || [],
    redirect: _91media_id_93hzLFKfDHvuMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: view3JcdOsCj1gMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: view3JcdOsCj1gMeta?.path ?? "lessons/:lesson_id()/view",
    meta: view3JcdOsCj1gMeta || {},
    alias: view3JcdOsCj1gMeta?.alias || [],
    redirect: view3JcdOsCj1gMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexz6wtaRZ6jkMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexz6wtaRZ6jkMeta?.path ?? "lessons",
    meta: indexz6wtaRZ6jkMeta || {},
    alias: indexz6wtaRZ6jkMeta?.alias || [],
    redirect: indexz6wtaRZ6jkMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93ow2teSlbLTMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93ow2teSlbLTMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93ow2teSlbLTMeta || {},
    alias: _91media_id_93ow2teSlbLTMeta?.alias || [],
    redirect: _91media_id_93ow2teSlbLTMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexvApLArBcMqMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexvApLArBcMqMeta?.path ?? "playlists/:playlist_id()",
    meta: indexvApLArBcMqMeta || {},
    alias: indexvApLArBcMqMeta?.alias || [],
    redirect: indexvApLArBcMqMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93uRr6tKM6WCMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93uRr6tKM6WCMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93uRr6tKM6WCMeta || {},
    alias: _91media_id_93uRr6tKM6WCMeta?.alias || [],
    redirect: _91media_id_93uRr6tKM6WCMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexmxIyuyL5AcMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexmxIyuyL5AcMeta?.path ?? "playlists",
    meta: indexmxIyuyL5AcMeta || {},
    alias: indexmxIyuyL5AcMeta?.alias || [],
    redirect: indexmxIyuyL5AcMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsY1xU2K4ihoMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsY1xU2K4ihoMeta?.path ?? "private-sessions",
    meta: private_45sessionsY1xU2K4ihoMeta || {},
    alias: private_45sessionsY1xU2K4ihoMeta?.alias || [],
    redirect: private_45sessionsY1xU2K4ihoMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsCixi4aOj0eMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingsCixi4aOj0eMeta?.path ?? "recordings",
    meta: recordingsCixi4aOj0eMeta || {},
    alias: recordingsCixi4aOj0eMeta?.alias || [],
    redirect: recordingsCixi4aOj0eMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsiMKMrCMSvPMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewsiMKMrCMSvPMeta?.path ?? "reviews",
    meta: reviewsiMKMrCMSvPMeta || {},
    alias: reviewsiMKMrCMSvPMeta?.alias || [],
    redirect: reviewsiMKMrCMSvPMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexlwem1qFIN7Meta?.name ?? "buy-product-product_id",
    path: indexlwem1qFIN7Meta?.path ?? "/buy/product/:product_id()",
    meta: indexlwem1qFIN7Meta || {},
    alias: indexlwem1qFIN7Meta?.alias || [],
    redirect: indexlwem1qFIN7Meta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmLzwCAOlgM3Meta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmLzwCAOlgM3Meta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmLzwCAOlgM3Meta || {},
    alias: confirmLzwCAOlgM3Meta?.alias || [],
    redirect: confirmLzwCAOlgM3Meta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmqrfRMP1HEdMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmqrfRMP1HEdMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmqrfRMP1HEdMeta || {},
    alias: confirmqrfRMP1HEdMeta?.alias || [],
    redirect: confirmqrfRMP1HEdMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendarrNRegQNR8cMeta?.name ?? "calendar",
    path: calendarrNRegQNR8cMeta?.path ?? "/calendar",
    meta: calendarrNRegQNR8cMeta || {},
    alias: calendarrNRegQNR8cMeta?.alias || [],
    redirect: calendarrNRegQNR8cMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatIRvQOexAWjMeta?.name ?? "chat",
    path: chatIRvQOexAWjMeta?.path ?? "/chat",
    meta: chatIRvQOexAWjMeta || {},
    alias: chatIRvQOexAWjMeta?.alias || [],
    redirect: chatIRvQOexAWjMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93ZoQWXxwFB3Meta?.name ?? "community-groups-group_id",
    path: _91group_id_93ZoQWXxwFB3Meta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93ZoQWXxwFB3Meta || {},
    alias: _91group_id_93ZoQWXxwFB3Meta?.alias || [],
    redirect: _91group_id_93ZoQWXxwFB3Meta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutYp507B95RGMeta?.name ?? "community-groups-group_id-about",
    path: aboutYp507B95RGMeta?.path ?? "about",
    meta: aboutYp507B95RGMeta || {},
    alias: aboutYp507B95RGMeta?.alias || [],
    redirect: aboutYp507B95RGMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedrPVz3zroV1Meta?.name ?? "community-groups-group_id-feed",
    path: feedrPVz3zroV1Meta?.path ?? "feed",
    meta: feedrPVz3zroV1Meta || {},
    alias: feedrPVz3zroV1Meta?.alias || [],
    redirect: feedrPVz3zroV1Meta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersO0TEUKboGkMeta?.name ?? "community-groups-group_id-members",
    path: membersO0TEUKboGkMeta?.path ?? "members",
    meta: membersO0TEUKboGkMeta || {},
    alias: membersO0TEUKboGkMeta?.alias || [],
    redirect: membersO0TEUKboGkMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editT111zk0tOqMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editT111zk0tOqMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editT111zk0tOqMeta || {},
    alias: community_45profile_45editT111zk0tOqMeta?.alias || [],
    redirect: community_45profile_45editT111zk0tOqMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93QKNk9BMWa8Meta?.name ?? "community-profile-id",
    path: _91id_93QKNk9BMWa8Meta?.path ?? "/community-profile/:id()",
    meta: _91id_93QKNk9BMWa8Meta || {},
    alias: _91id_93QKNk9BMWa8Meta?.alias || [],
    redirect: _91id_93QKNk9BMWa8Meta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityfC40m4lq8EMeta?.name ?? "community",
    path: communityfC40m4lq8EMeta?.path ?? "/community",
    meta: communityfC40m4lq8EMeta || {},
    alias: communityfC40m4lq8EMeta?.alias || [],
    redirect: communityfC40m4lq8EMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93l866JU0t7IMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93l866JU0t7IMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93l866JU0t7IMeta || {},
    alias: _91uuid_93l866JU0t7IMeta?.alias || [],
    redirect: _91uuid_93l866JU0t7IMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93oJGmmYZ8PFMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_93oJGmmYZ8PFMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93oJGmmYZ8PFMeta || {},
    alias: _91unique_id_93oJGmmYZ8PFMeta?.alias || [],
    redirect: _91unique_id_93oJGmmYZ8PFMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardPrV3Wtl38AMeta?.name ?? "dashboard",
    path: dashboardPrV3Wtl38AMeta?.path ?? "/dashboard",
    meta: dashboardPrV3Wtl38AMeta || {},
    alias: dashboardPrV3Wtl38AMeta?.alias || [],
    redirect: dashboardPrV3Wtl38AMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: index8UXKEQZfqPMeta?.name ?? "event-details-event_id",
    path: index8UXKEQZfqPMeta?.path ?? "/event/details/:event_id()",
    meta: index8UXKEQZfqPMeta || {},
    alias: index8UXKEQZfqPMeta?.alias || [],
    redirect: index8UXKEQZfqPMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutoF8P7vcY2kMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutoF8P7vcY2kMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutoF8P7vcY2kMeta || {},
    alias: checkoutoF8P7vcY2kMeta?.alias || [],
    redirect: checkoutoF8P7vcY2kMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45producthfbN0RR1A5Meta?.name ?? "event-details-event_id-select-product",
    path: select_45producthfbN0RR1A5Meta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45producthfbN0RR1A5Meta || {},
    alias: select_45producthfbN0RR1A5Meta?.alias || [],
    redirect: select_45producthfbN0RR1A5Meta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsS3Aj56D0IpMeta?.name ?? "events",
    path: eventsS3Aj56D0IpMeta?.path ?? "/events",
    meta: eventsS3Aj56D0IpMeta || {},
    alias: eventsS3Aj56D0IpMeta?.alias || [],
    redirect: eventsS3Aj56D0IpMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93jFdyS7VgPSMeta?.name ?? "gifts-uuid",
    path: _91uuid_93jFdyS7VgPSMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93jFdyS7VgPSMeta || {},
    alias: _91uuid_93jFdyS7VgPSMeta?.alias || [],
    redirect: _91uuid_93jFdyS7VgPSMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexhHawesFwW5Meta?.name ?? "gifts",
    path: indexhHawesFwW5Meta?.path ?? "/gifts",
    meta: indexhHawesFwW5Meta || {},
    alias: indexhHawesFwW5Meta?.alias || [],
    redirect: indexhHawesFwW5Meta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93qvDh7XxmO2Meta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93qvDh7XxmO2Meta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93qvDh7XxmO2Meta || {},
    alias: _91invitation_id_93qvDh7XxmO2Meta?.alias || [],
    redirect: _91invitation_id_93qvDh7XxmO2Meta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93mhV0xyf4BwMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93mhV0xyf4BwMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93mhV0xyf4BwMeta || {},
    alias: _91product_id_93mhV0xyf4BwMeta?.alias || [],
    redirect: _91product_id_93mhV0xyf4BwMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexkbQrUzdVF5Meta?.name ?? "index",
    path: indexkbQrUzdVF5Meta?.path ?? "/",
    meta: indexkbQrUzdVF5Meta || {},
    alias: indexkbQrUzdVF5Meta?.alias || [],
    redirect: indexkbQrUzdVF5Meta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93XG3kOnt5PtMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93XG3kOnt5PtMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93XG3kOnt5PtMeta || {},
    alias: _91invitation_unique_id_93XG3kOnt5PtMeta?.alias || [],
    redirect: _91invitation_unique_id_93XG3kOnt5PtMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: join5gQM8bYl5tMeta?.name ?? "join",
    path: join5gQM8bYl5tMeta?.path ?? "/join",
    meta: join5gQM8bYl5tMeta || {},
    alias: join5gQM8bYl5tMeta?.alias || [],
    redirect: join5gQM8bYl5tMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginqDm0AI38OvMeta?.name ?? "login",
    path: loginqDm0AI38OvMeta?.path ?? "/login",
    meta: loginqDm0AI38OvMeta || {},
    alias: loginqDm0AI38OvMeta?.alias || [],
    redirect: loginqDm0AI38OvMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutuSpskN8JKAMeta?.name ?? "logout",
    path: logoutuSpskN8JKAMeta?.path ?? "/logout",
    meta: logoutuSpskN8JKAMeta || {},
    alias: logoutuSpskN8JKAMeta?.alias || [],
    redirect: logoutuSpskN8JKAMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93iCzgYgO4b0Meta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93iCzgYgO4b0Meta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93iCzgYgO4b0Meta || {},
    alias: _91meeting_type_slug_93iCzgYgO4b0Meta?.alias || [],
    redirect: _91meeting_type_slug_93iCzgYgO4b0Meta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93mQc9Ysox6gMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93mQc9Ysox6gMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93mQc9Ysox6gMeta || {},
    alias: _91meeting_unique_id_93mQc9Ysox6gMeta?.alias || [],
    redirect: _91meeting_unique_id_93mQc9Ysox6gMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93QnmUZRPM6yMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93QnmUZRPM6yMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93QnmUZRPM6yMeta || {},
    alias: _91meeting_unique_id_93QnmUZRPM6yMeta?.alias || [],
    redirect: _91meeting_unique_id_93QnmUZRPM6yMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritesdQu5vRRAjaMeta?.name ?? "my-favorites",
    path: my_45favoritesdQu5vRRAjaMeta?.path ?? "/my-favorites",
    meta: my_45favoritesdQu5vRRAjaMeta || {},
    alias: my_45favoritesdQu5vRRAjaMeta?.alias || [],
    redirect: my_45favoritesdQu5vRRAjaMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studios5kFZKHyEsGMeta?.name ?? "my-studios",
    path: my_45studios5kFZKHyEsGMeta?.path ?? "/my-studios",
    meta: my_45studios5kFZKHyEsGMeta || {},
    alias: my_45studios5kFZKHyEsGMeta?.alias || [],
    redirect: my_45studios5kFZKHyEsGMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinkl9nLeym6BMeta?.name ?? "optin",
    path: optinkl9nLeym6BMeta?.path ?? "/optin",
    meta: optinkl9nLeym6BMeta || {},
    alias: optinkl9nLeym6BMeta?.alias || [],
    redirect: optinkl9nLeym6BMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93LhMhpW7DyQMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93LhMhpW7DyQMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93LhMhpW7DyQMeta || {},
    alias: _91episode_id_93LhMhpW7DyQMeta?.alias || [],
    redirect: _91episode_id_93LhMhpW7DyQMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: index4ijeRyOO23Meta?.name ?? "podcasts-podcast_id",
    path: index4ijeRyOO23Meta?.path ?? "/podcasts/:podcast_id()",
    meta: index4ijeRyOO23Meta || {},
    alias: index4ijeRyOO23Meta?.alias || [],
    redirect: index4ijeRyOO23Meta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexOpo5SI00N8Meta?.name ?? "podcasts",
    path: indexOpo5SI00N8Meta?.path ?? "/podcasts",
    meta: indexOpo5SI00N8Meta || {},
    alias: indexOpo5SI00N8Meta?.alias || [],
    redirect: indexOpo5SI00N8Meta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93JwpfIqydBGMeta?.name ?? "product-product_id",
    path: _91product_id_93JwpfIqydBGMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93JwpfIqydBGMeta || {},
    alias: _91product_id_93JwpfIqydBGMeta?.alias || [],
    redirect: _91product_id_93JwpfIqydBGMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: abouteMpAICp2a6Meta?.name ?? "product-product_id-about",
    path: abouteMpAICp2a6Meta?.path ?? "about",
    meta: abouteMpAICp2a6Meta || {},
    alias: abouteMpAICp2a6Meta?.alias || [],
    redirect: abouteMpAICp2a6Meta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentZpLP0nxDlOMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentZpLP0nxDlOMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contentZpLP0nxDlOMeta || {},
    alias: digital_45download_45contentZpLP0nxDlOMeta?.alias || [],
    redirect: digital_45download_45contentZpLP0nxDlOMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventsrJG3FeGTSBMeta?.name ?? "product-product_id-events",
    path: eventsrJG3FeGTSBMeta?.path ?? "events",
    meta: eventsrJG3FeGTSBMeta || {},
    alias: eventsrJG3FeGTSBMeta?.alias || [],
    redirect: eventsrJG3FeGTSBMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93rElh8p6KEkMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93rElh8p6KEkMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93rElh8p6KEkMeta || {},
    alias: _91media_id_93rElh8p6KEkMeta?.alias || [],
    redirect: _91media_id_93rElh8p6KEkMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplelIyAZwMOlGMeta?.name ?? "product-product_id-free-sample",
    path: free_45samplelIyAZwMOlGMeta?.path ?? "free-sample",
    meta: free_45samplelIyAZwMOlGMeta || {},
    alias: free_45samplelIyAZwMOlGMeta?.alias || [],
    redirect: free_45samplelIyAZwMOlGMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45products8jcVU0XEbJMeta?.name ?? "product-product_id-included-products",
    path: included_45products8jcVU0XEbJMeta?.path ?? "included-products",
    meta: included_45products8jcVU0XEbJMeta || {},
    alias: included_45products8jcVU0XEbJMeta?.alias || [],
    redirect: included_45products8jcVU0XEbJMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_934Dzgs6aLpxMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_934Dzgs6aLpxMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_934Dzgs6aLpxMeta || {},
    alias: _91media_id_934Dzgs6aLpxMeta?.alias || [],
    redirect: _91media_id_934Dzgs6aLpxMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewB6HCLqYP6HMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewB6HCLqYP6HMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewB6HCLqYP6HMeta || {},
    alias: viewB6HCLqYP6HMeta?.alias || [],
    redirect: viewB6HCLqYP6HMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexXqgQjsAB4WMeta?.name ?? "product-product_id-lessons",
    path: indexXqgQjsAB4WMeta?.path ?? "lessons",
    meta: indexXqgQjsAB4WMeta || {},
    alias: indexXqgQjsAB4WMeta?.alias || [],
    redirect: indexXqgQjsAB4WMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_934nFxAfhxatMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_934nFxAfhxatMeta?.path ?? "media/:media_id()",
    meta: _91media_id_934nFxAfhxatMeta || {},
    alias: _91media_id_934nFxAfhxatMeta?.alias || [],
    redirect: _91media_id_934nFxAfhxatMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexIwUYvnamPJMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexIwUYvnamPJMeta?.path ?? "playlists/:playlist_id()",
    meta: indexIwUYvnamPJMeta || {},
    alias: indexIwUYvnamPJMeta?.alias || [],
    redirect: indexIwUYvnamPJMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93tLkijbg5oKMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93tLkijbg5oKMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93tLkijbg5oKMeta || {},
    alias: _91media_id_93tLkijbg5oKMeta?.alias || [],
    redirect: _91media_id_93tLkijbg5oKMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexuixxtkeLM9Meta?.name ?? "product-product_id-playlists",
    path: indexuixxtkeLM9Meta?.path ?? "playlists",
    meta: indexuixxtkeLM9Meta || {},
    alias: indexuixxtkeLM9Meta?.alias || [],
    redirect: indexuixxtkeLM9Meta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsRuhCfs8giPMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsRuhCfs8giPMeta?.path ?? "private-sessions",
    meta: private_45sessionsRuhCfs8giPMeta || {},
    alias: private_45sessionsRuhCfs8giPMeta?.alias || [],
    redirect: private_45sessionsRuhCfs8giPMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsYvDKhGAN1EMeta?.name ?? "product-product_id-recordings",
    path: recordingsYvDKhGAN1EMeta?.path ?? "recordings",
    meta: recordingsYvDKhGAN1EMeta || {},
    alias: recordingsYvDKhGAN1EMeta?.alias || [],
    redirect: recordingsYvDKhGAN1EMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsRwP6b233BWMeta?.name ?? "product-product_id-reviews",
    path: reviewsRwP6b233BWMeta?.path ?? "reviews",
    meta: reviewsRwP6b233BWMeta || {},
    alias: reviewsRwP6b233BWMeta?.alias || [],
    redirect: reviewsRwP6b233BWMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexYgQNfQIjxJMeta?.name ?? "product",
    path: indexYgQNfQIjxJMeta?.path ?? "/product",
    meta: indexYgQNfQIjxJMeta || {},
    alias: indexYgQNfQIjxJMeta?.alias || [],
    redirect: indexYgQNfQIjxJMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexS9uRpWNldrMeta?.name ?? "profile",
    path: indexS9uRpWNldrMeta?.path ?? "/profile",
    meta: indexS9uRpWNldrMeta || {},
    alias: indexS9uRpWNldrMeta?.alias || [],
    redirect: indexS9uRpWNldrMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasessqgMJn5MXCMeta?.name ?? "profile-purchases",
    path: purchasessqgMJn5MXCMeta?.path ?? "/profile/purchases",
    meta: purchasessqgMJn5MXCMeta || {},
    alias: purchasessqgMJn5MXCMeta?.alias || [],
    redirect: purchasessqgMJn5MXCMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsvSZsTpeFCDMeta?.name ?? "profile-redemptions",
    path: redemptionsvSZsTpeFCDMeta?.path ?? "/profile/redemptions",
    meta: redemptionsvSZsTpeFCDMeta || {},
    alias: redemptionsvSZsTpeFCDMeta?.alias || [],
    redirect: redemptionsvSZsTpeFCDMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93frtiazd1lUMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93frtiazd1lUMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93frtiazd1lUMeta || {},
    alias: _91quiz_id_93frtiazd1lUMeta?.alias || [],
    redirect: _91quiz_id_93frtiazd1lUMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93htDjb7xl7FMeta?.name ?? "reset-password-uid-token",
    path: _91token_93htDjb7xl7FMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93htDjb7xl7FMeta || {},
    alias: _91token_93htDjb7xl7FMeta?.alias || [],
    redirect: _91token_93htDjb7xl7FMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: reset079y3IPYJoMeta?.name ?? "reset",
    path: reset079y3IPYJoMeta?.path ?? "/reset",
    meta: reset079y3IPYJoMeta || {},
    alias: reset079y3IPYJoMeta?.alias || [],
    redirect: reset079y3IPYJoMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopXl5b4CIyHmMeta?.name ?? "shop",
    path: shopXl5b4CIyHmMeta?.path ?? "/shop",
    meta: shopXl5b4CIyHmMeta || {},
    alias: shopXl5b4CIyHmMeta?.alias || [],
    redirect: shopXl5b4CIyHmMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signup06fyJR2taPMeta?.name ?? "signup",
    path: signup06fyJR2taPMeta?.path ?? "/signup",
    meta: signup06fyJR2taPMeta || {},
    alias: signup06fyJR2taPMeta?.alias || [],
    redirect: signup06fyJR2taPMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: liveK1oSrpgVlLMeta?.name ?? "streaming-event_id-live",
    path: liveK1oSrpgVlLMeta?.path ?? "/streaming/:event_id()/live",
    meta: liveK1oSrpgVlLMeta || {},
    alias: liveK1oSrpgVlLMeta?.alias || [],
    redirect: liveK1oSrpgVlLMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsjlGxeXN7ZfMeta?.name ?? "tips",
    path: tipsjlGxeXN7ZfMeta?.path ?? "/tips",
    meta: tipsjlGxeXN7ZfMeta || {},
    alias: tipsjlGxeXN7ZfMeta?.alias || [],
    redirect: tipsjlGxeXN7ZfMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93dnnDL20LjsMeta?.name ?? "waiver-uuid",
    path: _91uuid_93dnnDL20LjsMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93dnnDL20LjsMeta || {},
    alias: _91uuid_93dnnDL20LjsMeta?.alias || [],
    redirect: _91uuid_93dnnDL20LjsMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactijbODdiXhzMeta?.name ?? "widgets-calendars-compact",
    path: compactijbODdiXhzMeta?.path ?? "/widgets/calendars/compact",
    meta: compactijbODdiXhzMeta || {},
    alias: compactijbODdiXhzMeta?.alias || [],
    redirect: compactijbODdiXhzMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fullGswt0OjUkRMeta?.name ?? "widgets-calendars-full",
    path: fullGswt0OjUkRMeta?.path ?? "/widgets/calendars/full",
    meta: fullGswt0OjUkRMeta || {},
    alias: fullGswt0OjUkRMeta?.alias || [],
    redirect: fullGswt0OjUkRMeta?.redirect,
    component: () => import("/tmp/build_dab1367c/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]